import theme from './defaultTheme.js';
import darkColor from './darkColor.js';
function presetRadixUI() {
    return {
        theme,
        darkColor
    };
}
export { presetRadixUI as default };
//# sourceMappingURL=preset-radix-ui.js.map
